export default __webpack_public_path__ + "static/media/apple-store.918d3a68.svg";